// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__3RS0Z","title":"ClientCherryInfo_title__3qMjj","itemText":"ClientCherryInfo_itemText__h818Y"};